import script from "./grid-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-layout.vue?vue&type=script&setup=true&lang=js"

import "./grid-layout.vue?vue&type=style&index=0&id=f2b9f16a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b9f16a"]])

export default __exports__